<template>
<div>
    <md-table
      v-model="items"
      :md-sort.sync="currentSort"
      :md-sort-order.sync="currentSortOrder"
      :md-sort-fn="customSort"
      class="dashboard_box"
    >
      <md-table-row slot="md-table-row" slot-scope="{ item }" >
        <md-table-cell
          md-label="Id"
          md-id="align-center"
        >
          {{ item.id }}
        </md-table-cell>
        <md-table-cell md-label="Usuario" md-sort-by="userModel.username">{{
          item.userModel.username
        }}</md-table-cell>
        <md-table-cell md-label="Acción" md-sort-by="action">{{
          item.action
        }}</md-table-cell>
        <md-table-cell md-label="Detalles" md-sort-by="action">{{
          item.description
        }}</md-table-cell>
        <md-table-cell md-label="Fecha" md-sort-by="creationDate">{{
           formatDate(item.creationDate)
        }}</md-table-cell>
        <md-table-cell md-label="Rol" md-sort-by="userModel.role">{{
          item.userModel.role
        }}</md-table-cell>
      </md-table-row>
    </md-table>
    <div class="pagination-container">
      <div class="pagination-options" v-if="!loading">
        Items per page:
        <select v-model="pageSize" @blur="handlePageSizeChange($event)">
          <option v-for="size in pageSizes" :key="size" :value="size">
            {{ size }}
          </option>
        </select>
        <div style="float: right">Items total: {{ this.count }}</div>
      </div>
      <div class="pagination-wrapper">
        <b-pagination
          v-if="!loading"
          v-model="page"
          :total-rows="count"
          :per-page="pageSize"
          prev-text="Anterior"
          next-text="Siguiente"
          @change="handlePageChange"
        ></b-pagination>
      </div>
    </div>
</div>
</template>
<script>

import axios from '@/services/http-common';
import authHeader from '@/services/auth-header';

export default {
  name: 'log-standard-table',
  props: {
    username: {
      type: String,
      default: null,
    },
    role: {
      type: String,
      default: null,
    },
    action: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      items: [],
      currentIndex: -1,
      searchTitle: '',
      page: 1,
      count: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20],

      currentSort: 'creationDate',
      currentSortOrder: 'desc',
      loading: true,
    };
  },
  created() {
    this.getItems();
  },

  watch: {
    username() {
      this.getItems();
    },
    role() {
      this.getItems();
    },
    action() {
      this.getItems();
    },
    currentSort() {
      this.getItems();
    },
    currentSortOrder() {
      this.getItems();
    },
  },
  methods: {
    formatDate(value) {
      const date = new Date(value);
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2);
      const day = (`0${date.getDate()}`).slice(-2);
      const hours = (`0${date.getHours()}`).slice(-2);
      const minutes = (`0${date.getMinutes()}`).slice(-2);
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },
    getRequestParams(page, pageSize) {
      const params = {};
      params.username = this.username;
      params.role = this.role;
      params.action = this.action;
      params.sort = this.currentSort;
      params.direction = this.currentSortOrder;

      if (page) {
        params.page = page - 1;
      }

      if (pageSize) {
        params.size = pageSize;
      }

      return params;
    },

    getItems() {
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_API_URL}log`, { headers: authHeader(), params: this.getRequestParams(this.page, this.pageSize) })
        .then((response) => {
          this.items = response.data.content;
          this.count = response.data.totalElements;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.getItems();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.getItems();
    },

    customSort() {
      return [];
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
<style lang="scss">

</style>
